export function useKeys(state, props) {
    var onEnterUp = props.onEnterUp, onEnterDown = props.onEnterDown, onEscapeUp = props.onEscapeUp, onEscapeDown = props.onEscapeDown;
    function keyUp(event) {
        if (event.key === Keys.Enter)
            onEnterUp && onEnterUp(event);
        if (event.key === Keys.Escape)
            onEscapeUp && onEscapeUp(event);
    }
    function keyDown(event) {
        if (event.key === Keys.Enter)
            onEnterDown && onEnterDown(event);
        if (event.key === Keys.Escape)
            onEscapeDown && onEscapeDown(event);
    }
    return {
        onKeyUp: keyUp,
        onKeyDown: keyDown,
    };
}
